module.exports = __webpack_public_path__ + "img/living_room.be5030ca.webp";